import { SlidersHorizontal, Loader2, Sparkles } from "lucide-react";

export default function SummaryBar({
  summary,
  nbHits,
  resultLabel = { singular: "résultat", plural: "résultats" },
  filterLoading,
  showFilters,
  onToggleFilters,
  activeCount,
}) {
  return (
    <div className="flex items-center gap-2 pt-5 pb-1">

      {/* Résumé LLM */}
      <div className="flex items-center gap-1.5 flex-1 min-w-0">
        {summary && <Sparkles className="w-3.5 h-3.5 text-teal-400 shrink-0" />}
        {filterLoading ? (
          <span className="flex items-center gap-1.5 text-xs text-gray-500">
            <Loader2 className="w-3 h-3 animate-spin shrink-0" />
            Mise à jour…
          </span>
        ) : summary ? (
          <p className="font-semibold text-white truncate">{summary}</p>
        ) : null}
      </div>

      {/* Nb résultats */}
      {nbHits > 0 && (
        <span className="text-xs text-gray-500 shrink-0">
          {nbHits} {nbHits !== 1 ? resultLabel.plural : resultLabel.singular}
        </span>
      )}

      {/* Bouton Filtres */}
      <button
        onClick={onToggleFilters}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition shrink-0 ${
          showFilters || activeCount > 0
            ? "bg-teal-500 text-white"
            : "bg-gray-800 text-gray-300 hover:bg-gray-700"
        }`}
      >
        <SlidersHorizontal className="w-3.5 h-3.5" />
        Filtres
        {activeCount > 0 && (
          <span className="w-4 h-4 bg-white/20 rounded-full flex items-center justify-center text-[10px] font-bold">
            {activeCount}
          </span>
        )}
      </button>
    </div>
  );
}
